/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainer5_story = {
    readonly id: string;
    readonly isClosed: boolean;
    readonly closedAt: string | null;
    readonly settings: {
        readonly live: {
            readonly enabled: boolean;
        };
    };
    readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_story" | "ReplyListContainer6_story">;
    readonly " $refType": "ReplyListContainer5_story";
};
export type ReplyListContainer5_story$data = ReplyListContainer5_story;
export type ReplyListContainer5_story$key = {
    readonly " $data"?: ReplyListContainer5_story$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer5_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainer5_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isClosed",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "closedAt",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "StorySettings",
            "kind": "LinkedField",
            "name": "settings",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "LiveConfiguration",
                    "kind": "LinkedField",
                    "name": "live",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "enabled",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListCommentContainer_story"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainer6_story"
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '2871f7cd5f6a33efdcdfe9bfb6090dac';
export default node;
